var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllnftsLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#fff",
    stroke: "#E5E8EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M23 25C23 23.8954 23.8954 23 25 23H37C38.1046 23 39 23.8954 39 25V37C39 38.1046 38.1046 39 37 39H25C23.8954 39 23 38.1046 23 37V25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M23 44C23 42.8954 23.8954 42 25 42H37C38.1046 42 39 42.8954 39 44V56C39 57.1046 38.1046 58 37 58H25C23.8954 58 23 57.1046 23 56V44Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M23 63C23 61.8954 23.8954 61 25 61H37C38.1046 61 39 61.8954 39 63V75C39 76.1046 38.1046 77 37 77H25C23.8954 77 23 76.1046 23 75V63Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M42 25C42 23.8954 42.8954 23 44 23H56C57.1046 23 58 23.8954 58 25V37C58 38.1046 57.1046 39 56 39H44C42.8954 39 42 38.1046 42 37V25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M42 44C42 42.8954 42.8954 42 44 42H56C57.1046 42 58 42.8954 58 44V56C58 57.1046 57.1046 58 56 58H44C42.8954 58 42 57.1046 42 56V44Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M42 63C42 61.8954 42.8954 61 44 61H56C57.1046 61 58 61.8954 58 63V75C58 76.1046 57.1046 77 56 77H44C42.8954 77 42 76.1046 42 75V63Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M61 25C61 23.8954 61.8954 23 63 23H75C76.1046 23 77 23.8954 77 25V37C77 38.1046 76.1046 39 75 39H63C61.8954 39 61 38.1046 61 37V25Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M61 44C61 42.8954 61.8954 42 63 42H75C76.1046 42 77 42.8954 77 44V56C77 57.1046 76.1046 58 75 58H63C61.8954 58 61 57.1046 61 56V44Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M61 63C61 61.8954 61.8954 61 63 61H75C76.1046 61 77 61.8954 77 63V75C77 76.1046 76.1046 77 75 77H63C61.8954 77 61 76.1046 61 75V63Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllnftsLight);
export default __webpack_public_path__ + "static/media/allnfts-light.e1f05b7efff62dd281c834f8fc198341.svg";
export { ForwardRef as ReactComponent };